import { Avatar, Box, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { Chip } from '@mui/material';
import React from 'react'
import { CommonTableColumn } from '../../../common-components/CommonTable';
import { IUser } from '../../../layouts/AdminLayout/slice/types';
import useUserSessionsListHandler from '../../../layouts/AdminLayout/hooks/useUserSessionsListHandler';

export function useUsersTableHeader() {
    const { setSelectedUserToView } = useUserSessionsListHandler();
    const columns = React.useMemo<Array<CommonTableColumn<IUser & { sessionCount?: number }>>>(() => {
        return [
          {
            key: 'user',
            header: 'User',
            minWidth: 260,
            render: (u) => (
              <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0 }}>
                <Avatar sx={{ width: 34, height: 34 }}>{(u.name?.trim()?.[0] ?? u.email?.trim()?.[0] ?? '?').toUpperCase()}</Avatar>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700 }} noWrap>
                    {u.name || '—'}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {u.email || '—'}
                  </Typography>
                </Box>
              </Stack>
            ),
          },
          {
            key: 'role',
            header: 'Role',
            width: 120,
            render: (u) => <Chip size="small" label={u.role ?? '—'} variant="outlined" />,
          },
          {
            key: 'product',
            header: 'Product',
            width: 140,
            render: (u) => <Chip size="small" label={u.productId ?? '—'} />,
          },
          {
            key: 'externalUserId',
            header: 'External ID',
            minWidth: 160,
            render: (u) => (
              <Typography variant="body2" color="text.secondary" noWrap>
                {u.externalUserId ?? '—'}
              </Typography>
            ),
          },
          {
            key: 'sessions',
            header: 'Sessions',
            width: 160,
            render: (u) => (
              <Typography
                variant="body2"
                color="primary"
                noWrap
                sx={{ cursor: 'pointer', fontWeight: 600 }}
                onClick={() => setSelectedUserToView(u.externalUserId ?? null)}
              >
                {u.sessionCount || 0}
              </Typography>
            ),
          },
          {
            key: 'createdAt',
            header: 'Created',
            width: 160,
            render: (u) => (
              <Typography variant="body2" color="text.secondary" noWrap>
                {u.createdAt ? moment(u.createdAt).format('MMM D, YYYY') : '—'}
              </Typography>
            ),
          },
          
        ];
      }, [setSelectedUserToView]);
  return columns;
}
